<template >
  <div class="body">
    <el-container>
      <left-meun ref="_leftMeun" @initData="initData"></left-meun>
      <el-container>
        <el-header class="header_layout">
          <headerLayout :title="meunTitle"></headerLayout>
        </el-header>
        <el-main class="main">
          <div class="mainbody">
            <div class="tableHead">
              <div class="box">
                <p class="title1">已筹金额</p>
                <p class="title2">{{ current_amount }}元</p>
              </div>
              <div class="aLine"></div>
              <div class="box">
                <p class="title1">参与人次</p>
                <p class="title2">{{ donation_count }}次</p>
              </div>
              <div class="aLine"></div>
              <div class="box">
                <p class="title1">进行中的筹款项目</p>
                <p class="title2">{{ donation_project_count }}个</p>
              </div>
            </div>
            <div style="padding: 16px 32px 16px 0px; background: #ffffff; border-radius: 2px">
              <span class="title">项目列表</span>
              <el-button type="primary" size="small" style="float: right" @click="addInfo()">新建</el-button>
            </div>
            <div class="aLine"></div>
            <div class="tableInfo">
              <el-table :data="data_list" @filter-change="filterChange" @sort-change="changeTableSort">
                <el-table-column prop="order" label="排序" min-width="1"></el-table-column>
                <el-table-column prop="title" label="项目名称" min-width="1"></el-table-column>
                <el-table-column prop="progress" label="捐助进度" min-width="1" sortable></el-table-column>
                <el-table-column prop="donation_times" label="捐助人次" min-width="1" sortable></el-table-column>
                <el-table-column prop="status" label="状态" min-width="1" :filters="optionsExamine" filter-placement="bottom-end" column-key="filterResult"></el-table-column>
                <el-table-column prop="create_time" label="添加时间" min-width="1" sortable></el-table-column>
                <el-table-column prop="operating" label="操作" min-width="1" align="left">
                  <template slot-scope="scope">
                    <el-button class="operateText" size="mini" type="text" @click="editInfo(scope.row)">编辑</el-button>
                    <el-button class="operateText" size="mini" type="text" @click="deleteInfo(scope.row)">删除</el-button>
                  </template>
                </el-table-column>
              </el-table>
              <el-pagination
                :key="elementui_page_key"
                class="elPagination"
                background
                layout="prev, pager, next"
                :page-size="pageMaxSize"
                :page-count="pageCount"
                :current-page="currentPage"
                @current-change="currentChange"
              ></el-pagination>
            </div>
          </div>
        </el-main>
      </el-container>
    </el-container>
  </div>
</template>

<script>
import * as StrUtils from '@/utils/strUtils.js'
import * as Utils from '@/utils/utils.js'
import { URL_PATH, LIST_PAGE_MAX_SIZE } from '@/config/config'
import * as Constant from '@/utils/constant.js'
import leftMeun from '@/components/layout/leftMeun'
import headRight from '@/components/layout/headRight'
import headerLayout from '@/components/layout/headerLayoutWxapp'

export default {
  components: {
    leftMeun,
    headRight,
    headerLayout
  },
  activated() {
    this.getList()
  },
  deactivated() {},
  data() {
    return {
      meunItem: null,
      meunTitle: '',
      urlPath: URL_PATH,
      data_list: [], //数据列表
      optionsExamine: Constant.options_examine_1,
      elementui_page_key: 0,
      pageCount: 0, // 所有页数
      pageMaxSize: LIST_PAGE_MAX_SIZE,
      currentPage: 1,
      current_amount: 0,
      donation_count: 0,
      donation_project_count: 0
    }
  },
  methods: {
    initData(meunItem) {
      this.meunItem = meunItem
      this.meunTitle = this.meunItem.name
      this.getList()
    },
    getList: function () {
      this.$api
        .donationList({
          token: localStorage.getItem('token'),
          page: this.currentPage,
          limit: this.pageMaxSize,
          screen_status: this.screen_status,
          order: this.order
        })
        .then(({ data }) => {
          this.current_amount = data.Data.current_amount
          this.donation_count = data.Data.donation_count
          this.donation_project_count = data.Data.donation_project_count

          let current_page = Utils.listPage(data, this.currentPage)
          if (current_page) {
            this.currentPage = current_page
            this.getList()
          }
          this.pageCount = data.Data.pageCount
          this.data_list = data.Data.model
          this.data_list.forEach(info => {
            this.optionsExamine.forEach(examin => {
              if (info.status == examin.value) {
                info.status = examin.text
              }
            })
            if (info.progress) {
              info.progress = info.progress + '%'
            }
            info.donation_times = info.donation_times + '次'
            info.create_time = Utils.dateFormat(info.create_time * 1000)
          })
        })
        .catch(({ error }) => {})
    },
    // 排序
    changeTableSort(column) {
      this.order = StrUtils.getPropOrder(column)
      this.getList()
    },
    // 过滤
    filterChange(filters) {
      this.screen_status = StrUtils.getStr4List1(filters.filterResult)
      if (this.screen_status == '') this.screen_status = undefined
      this.getList()
    },
    currentChange(val) {
      this.elementui_page_key++
      this.currentPage = val
      this.getList()
    },
    // 新建
    addInfo() {
      this.$router.push({
        path: '/wxapp/donation_add'
      })
    },
    // 编辑
    editInfo(row) {
      this.$router.push({
        path: '/wxapp/donation_add',
        query: {
          id: row.id
        }
      })
    },
    // 删除
    deleteInfo(row) {
      this.$confirm('是否删除此记录?', {
        confirmButtonText: '确定',
        cancelButtonText: '取消'
      })
        .then(() => {
          this.$api
            .delDonation({
              token: localStorage.getItem('token'),
              id: row.id
            })
            .then(({ data }) => {
              this.getList()
            })
            .catch(({ error }) => {})
        })
        .catch(() => {})
    }
  }
}
</script>

<style lang="less" scoped>
.mainbody {
  // overflow: hidden;
  // background-color: #ffffff;
  border-radius: 5px;
  // padding-bottom: 58px;
}
.mainbody .title {
  font-family: PingFang SC;
  font-style: normal;
  font-weight: 800;
  font-size: 16px;
  line-height: 24px;
  color: rgba(0, 0, 0, 0.85);
  padding: 16px 32px;
}
.mainbody .aLine {
  background-color: #e9e9e9;
  height: 1px;
}
.mainbody .tableHead {
  background-color: #ffffff;
  box-sizing: border-box;
  margin-bottom: 16px;
  overflow: hidden; /*溢出的部分隐藏*/
}
.mainbody .tableHead .box {
  padding: 24px;
  width: 29%;
  height: 50px;
  float: left;
  text-align: center;
}
.mainbody .tableHead .title1 {
  font-family: PingFang SC;
  font-style: normal;
  font-weight: normal;
  font-size: 14px;
  line-height: 22px;
  color: #000000;
}
.mainbody .tableHead .title2 {
  font-family: Roboto;
  font-style: normal;
  font-weight: normal;
  font-size: 24px;
  line-height: 32px;
  color: #000000;
}
.mainbody .tableHead .aLine {
  float: left;
  background-color: #e9e9e9;
  width: 1px;
  height: 56px;
  margin-top: 25px;
}
.mainbody .tableInfo {
  background-color: #ffffff;
  box-sizing: border-box;
  // margin-top: 24px;
  padding-left: 32px;
  padding-right: 32px;
  padding-bottom: 32px;
  overflow: hidden; /*溢出的部分隐藏*/
}
</style>


// WEBPACK FOOTER //
// src/pages/wxapp/donationList.vue